<script lang="ts">
	import DangerHint from '$lib/atoms/badges/DangerHint.svelte'
	import FootnoteHint from '$lib/atoms/badges/FootnoteHint.svelte'
	import type { EquivalenceMark } from './utils/equivalence'
	import type { DangerKind } from '$types/enums'

	interface Props {
		name: string
		/** every reason this value makes the material dangerous */
		danger?: DangerKind[]
		/** parameter-specific footnote of the regulation, empty when the value has none */
		footnote?: string
		/** set when an equivalence footnote moves this value out of, or into, the combined result */
		equivalence?: EquivalenceMark
	}

	let { name, danger = [], footnote = '', equivalence }: Props = $props()
</script>

<!-- the chip area is always reserved at full width so the names stay aligned across rows -->
<div class="value-name">
	<span class="value-name-chips">
		<DangerHint kinds={danger} />
		<FootnoteHint {footnote} {equivalence} />
	</span>
	{name}
</div>

<style>
	.value-name {
		display: flex;
		align-items: center;

		/* AnalysisTable shares these so its header keeps the same offset */
		gap: var(--value-chip-gap, 0.5rem);
	}

	.value-name-chips {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex: none;

		/*
		 * room for both chips plus the gap between them. A single chip is centred in it, and the two
		 * together measure exactly this width, so they end up flush against its sides.
		 */
		width: calc(2 * var(--value-chip-slot, 2rem) + var(--value-chip-gap, 0.5rem));
		gap: var(--value-chip-gap, 0.5rem);
	}
</style>
